<template>
  <div class="s-concat">
    <div class="s-concat2">
      <div class="close iconfont icon-close-line" @click="hide"></div>
      <div class="concat-box">
        <div class="concat-pic"></div>
        <div class="concat-info">
          <span class="t1">联系我们</span>
          <div class="tt">
            <!-- <span class="t2"></span> -->
            <a href="tel:0745-8889853" class="t2">0745-8889853</a>
            <div class="phone ico ico-tel blue"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { },
  data(){
    return{
       
    }
  },
  methods:{
    hide(){
      this.$emit("hide")
    }
  },
}
</script>
<style scoped lang="scss">
  .s-concat{
      // padding-bottom: 100rem;
      
    .s-concat2{
      background: rgba($color: #fff, $alpha: 0.8);
      border: 2rem solid var(--organColor);
      border-radius: 10rem;
      width: calc(100vw - 21rem * 2);
      box-sizing: border-box;
      display: flex;
      position: relative;
      max-width: var(--maxWidth);
      margin: 0 auto;
    }
    .close{
      position: absolute;
      right: 12rem;
      top: 5rem;
      color: var(--fontGray);
      font-size: 20rem;
      cursor: pointer;
    }
    .concat-pic{
      width: 96rem;
      height: 96rem;
      background: #FFEBDB;
      border-radius: 8rem;
      margin-right: 19rem;
      background: url(../assets/images/concat.png) center center no-repeat;
      background-size: cover;
    }
    .concat-box{
      display: flex;
    }
    .concat-info{
      display: flex;
      justify-content: center;
      flex-direction: column;
      .t1{
        font-size: 18rem;
        font-weight: 400;
        color: #222;
      }
      .tt{
        display: flex;
        align-items: center;
        color: var(--blueColor);
        margin-top: 15rem;
        cursor: pointer;
        .t2{
          font-size: 20rem;
          font-family: 'HarmonyOS Sans SC';
          color: var(--blueColor);
        }
        .phone{
          font-size: 20rem;
          margin-left: 5rem;
          width: 20rem;
          height: 20rem;
        }
      }
    }
  }

</style>